import styled, { css } from 'styled-components';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    object-fit: contain;
  }

  .slick-slider {
    position: relative;
  }

  .slick-list {
    height: 100%;
  }

  .slick-track {
    display: flex;
  }

  .slick-slide {
    flex: none;
    display: flex;
    align-items: center;

    > div {
      width: 100%;
    }
  }
`;

export const btnStd = css`
  width: 50px;
  height: 50px;
  border: 0;
  background-color: transparent;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;

  > svg {
    opacity: 0.35;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const NextBtnStd = styled.button`
  ${btnStd};
  right: 0;
`;

export const PrevBtnStd = styled.button`
  ${btnStd};
  left: 0;

  > svg {
    transform: rotate(180deg);
  }
`;
